module.exports = __webpack_public_path__ + "static/img/product-item-up.81122f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recharge/pc/product-item-up.png
// module id = O2T9
// module chunks = 1